module.exports = __webpack_public_path__ + "static/media/amp-support-icon.566ff737.svg";